<template>
  <v-list-item class="main-menu-item" link :href="this.href">
    <v-list-item-content>
      <div class="menu-1 d-flex justify-start">
        <div class="menu-triangle"></div>
        <div
          :class="{
            'menu-title-1': true,
            capitalized: subcategory.hideId
          }"
        >
          {{ subcategory.hideId ? subcategory.name : subcategory.id }}
        </div>
        <div class="menu-subtitle-1" v-if="!subcategory.hideId">
          {{ subcategory.name }}
        </div>
      </div>
      <div class="menu-2" v-if="subcategory.title">
        <div class="menu-title-2 d-flex justify-start">
          <div class="menu-dot"></div>
          <div
            class="menu-title-2-text"
            :class="subcategory.subtitle ? 'bold' : ''"
          >
            {{ subcategory.title }}
          </div>
        </div>
        <div class="menu-subtitle-2" v-if="subcategory.subtitle">
          {{ subcategory.subtitle }}
        </div>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { MENU_CATEGORIES } from '@/consts/categories'

export default {
  props: {
    categoryId: String,
    subcategory: Object,
    languageCode: String
  },
  computed: {
    href() {
      var href =
        '/category/' +
        MENU_CATEGORIES[this.categoryId].urlName +
        '/' +
        this.subcategory.id
      if (this.languageCode) {
        href += '/' + this.languageCode
      }
      return href
    }
  }
}
</script>
